export const toDecimalIta = (value) => {
    let numero;

    // Se è già un numero, lo usiamo così com'è
    if (typeof value === 'number') {
        numero = value;
    }
    // Altrimenti, se è una stringa, la puliamo e la trasformiamo in numero
    else if (typeof value === 'string') {
        // Rimuove tutti i simboli €, gli spazi iniziali/finali
        let pulito = value.replace(/€/g, '').trim();

        // Se ci aspettiamo possibili formati "1.234,56" in stile it-IT:
        //   - Rimuoviamo i punti (migliaia)
        //   - Sostituiamo la virgola con il punto (decimale) per parseFloat
        pulito = pulito.replace(/\./g, '').replace(',', '.');

        // Proviamo a convertirlo in numero
        numero = parseFloat(pulito);

        // Se non è un numero valido, ritorniamo un messaggio o gestiamo l'errore
        if (isNaN(numero)) {
            return 'Valore non numerico';
        }
    } else {
        // Tipo non gestito
        return 'Valore non numerico';
    }

    // Infine formattiamo il valore come decimale in stile it-IT
    return numero.toLocaleString('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

export const formatEuro = (value) => {
    if (value == null || value === "") return "€ 0";

    const num =
        typeof value === "number"
            ? value
            : Number(String(value).replace(",", "."));

    if (!Number.isFinite(num)) return "€ 0,0";

    const formatted = new Intl.NumberFormat("it-IT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(num);

    return `€ ${formatted}`;
};
